import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, cssVar } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys);
const resetStyles = {
  overflow: "visible",
  lineHeight: "1.5",
  boxSizing: "border-box",
  wordWrap: "break-word"
};
const $height = cssVar("input-height");
const $fontSize = cssVar("input-font-size");
const $iconHeight = cssVar("icon-height");
const $iconWidth = cssVar("icon-width");
const getSizeStyles = (size2) => {
  return {
    [$fontSize.variable]: `var(--vimeo-fontSizes-input-${size2})`,
    [$height.variable]: `var(--vimeo-sizes-${size2})`,
    svg: {
      [$iconHeight.variable]: `calc(var(--vimeo-fontSizes-input-${size2}) * 1.5)`,
      [$iconWidth.variable]: `calc(var(--vimeo-fontSizes-input-${size2}) * 1.5)`
    }
  };
};
const size = {
  xl: getSizeStyles("xl"),
  lg: getSizeStyles("lg"),
  md: getSizeStyles("md"),
  sm: getSizeStyles("sm"),
  xs: {
    ...getSizeStyles("xs")
  }
};
const sizes = {
  xl: {
    field: size.xl,
    group: size.xl
  },
  lg: {
    field: size.lg,
    group: size.lg
  },
  md: {
    field: size.md,
    group: size.md
  },
  sm: {
    field: size.sm,
    group: size.sm
  },
  xs: {
    field: size.xs,
    group: size.xs
  }
};
const underline = {
  field: {
    outline: "none",
    border: "none",
    borderRadius: 0,
    borderBottom: "1px solid",
    borderBottomColor: "input-border",
    _focus: {
      outline: "none",
      border: "none",
      borderBottom: "2px solid",
      borderBottomColor: "blue.500",
      boxShadow: "unset",
      paddingBottom: "calc(0.5em - 1px)"
      //offset for the extra 1px on the border
    }
  }
};
const baseStyle = {
  field: {
    height: $height.reference,
    fontSize: $fontSize.reference,
    padding: "0.5em",
    border: "1px solid",
    borderColor: "input-border",
    borderRadius: "0.25rem",
    bgColor: "transparent",
    color: "text-primary",
    transition: "all 120ms ease-in-out 0s",
    width: "100%",
    margin: "0",
    ...resetStyles,
    boxShadow: "0 0 0 0px rgba(0,173,239,1)",
    '[type="search"]': {
      WebkitAppearance: "textfield",
      outlineOffset: "-2px"
    },
    '[type="search"]::-webkit-search-decoration': {
      WebkitAppearance: "none !important"
    },
    '[type="number"]::-webkit-inner-spin-button': {
      WebkitAppearance: "none !important"
    },
    '[type="number"]::-webkit-outer-spin-button': {
      WebkitAppearance: "none !important"
    },
    _hover: {
      borderColor: "input-border-hover"
    },
    _invalid: {
      borderColor: "status-negative"
    },
    _focus: {
      outline: "none",
      boxShadow: "0 0 0 1px rgba(0,173,239,1)",
      borderColor: "blue.500",
      transition: "box-shadow 120ms ease-in-out 0s"
      //preventing the weird transition of the border-color changing
    },
    _disabled: {
      backgroundColor: "grayscale.50",
      pointerEvents: "none",
      borderColor: "rgba(0,0,0,0.1)",
      _dark: {
        backgroundColor: "grayscale.850",
        borderColor: "rgba(255,255,255,0.1)"
      }
    }
  }
};
const variants = {
  underline
};
const defaultProps = {
  size: "md",
  status: "neutral"
};
let Input = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants,
  // @ts-ignore - Added 'status' property, not a default Chakra prop, a convention from Iris
  defaultProps
});

export { Input, baseStyle, defaultProps, sizes, variants };
